<template>
  <!-- Only rendered for someone who can see project files or jobs; otherwise
       the page is just the overview, exactly as before. Deliberately plain
       labels: no count and no expiry marker here — the tabs themselves show
       those. -->
  <b-nav
    v-if="showFiles || showJobs"
    tabs
    class="project-page-tabs"
    role="tablist"
    data-test="project-page-tabs"
  >
    <b-nav-item
      :active="active === 'overview'"
      role="presentation"
      data-test="tab-overview"
      @click="$emit('change', 'overview')"
    >
      Overview
    </b-nav-item>
    <b-nav-item
      v-if="showFiles"
      :active="active === 'files'"
      role="presentation"
      data-test="tab-files"
      @click="$emit('change', 'files')"
    >
      Files
    </b-nav-item>
    <b-nav-item
      v-if="showJobs"
      :active="active === 'jobs'"
      role="presentation"
      data-test="tab-jobs"
      @click="$emit('change', 'jobs')"
    >
      Jobs
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'ProjectPageTabs',

  props: {
    // 'overview' | 'files' | 'jobs'
    active: { type: String, default: 'overview' },
    // Whether the user can see project files at all.
    showFiles: { type: Boolean, default: false },
    // Whether the user can see the jobs linked to this project.
    showJobs: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
// Same tab treatment as the panel's own Files | Archived tabs and DESIGN.md:
// gray-500 idle, gray-900 active, gray-200 rule.
.project-page-tabs {
  border-bottom-color: #e5e7eb;

  /deep/ .nav-link {
    color: #6b7280;
    font-weight: 600;

    &.active {
      color: #111827;
    }
  }
}
</style>
